import { Observable } from 'rxjs';
import { ApiRecordType, FragmentId, MediaObjectId } from '../../core/public_api';
import { IUploadItem } from '../entities/upload-item.entity';
import { UploadStatus } from '../upload.module';

export abstract class AbstractUploadSandboxService {
    abstract init(): void;

    abstract uploadFile(
        file: File,
        zoneId: string,
        parentRecordId: MediaObjectId,
        recordType: ApiRecordType,
        group?: string
    ): void;

    abstract uploadFiles(
        files: FileList,
        zoneId: string,
        parentRecordId: MediaObjectId,
        recordType: ApiRecordType,
        group: string
    ): Observable<boolean>;

    abstract uploadNewOriginal(file: File, fragmentId: FragmentId): Observable<boolean>;

    abstract cancelOrAbortUpload(uploadItem: IUploadItem, abort?: boolean): void;

    abstract cancelUpload(syncData: { tempId: string; uploadItemUpdate: Partial<IUploadItem> }): void;

    abstract pauseUpload(uploadItem: IUploadItem): void;

    abstract resumeUpload(uploadItem: IUploadItem): void;

    abstract onBrowserRefresh(): Observable<void>;

    abstract isPausable(upload: IUploadItem): boolean;

    abstract isResumable(upload: IUploadItem): boolean;

    protected isRunningUpload(upload: IUploadItem): boolean {
        return (
            upload.state.status === UploadStatus.WAITING ||
            upload.state.status === UploadStatus.PREPARING ||
            upload.state.status === UploadStatus.UPLOADING ||
            upload.state.status === UploadStatus.PAUSED ||
            upload.state.status === UploadStatus.CHECKING_COMPLETION
        );
    }
}
